import React from "react";
import {
  BarChart,
  ComposedChart,
  Line,
  Brush,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

import { ReactComponent as Easel } from "../../assets/icons/easel.svg";
import { Modal } from "react-bootstrap";
import theme from "../../styles/theme";

import "../../styles-arabic/analytics.rtl.css";

import { toArabicNumber } from "../../utils/arabicConversions";
import useAnalytics from "../../custom-hooks/useAnalytics";

const AnalyticsArabic = ({ show, handleClose }) => {
  const {
    analyticsPerCollectionData,
    analyticsPerYearData,
    activeGraph,
    handleButtonClick,
    getPng,
    chartRef,
    handleChartDownload,
    handleResultsDownload,
  } = useAnalytics();

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="my-modal">
      <div className="modal-header-style">
        <div className="modal-flex-box">
          <Easel
            alt="easel"
            style={{
              width: "2rem",
              fill: theme.colors.mainRed,
              transform: "scale(1.2)",
            }}
          />
          <div>
            <h4 className="modal-title-style">التحليلات</h4>
            <hr className="line-style"></hr>
          </div>
          <button
            type="button"
            className="modal-close-style"
            aria-label="Close"
            onClick={handleClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>

      <Modal.Body>
        <div style={{ padding: "1rem", fontFamily: "Roboto" }}>
          <div className="col">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                className={
                  activeGraph === "collection"
                    ? "active-button"
                    : "inactive-button"
                }
                onClick={() => handleButtonClick("collection")}
              >
                لكل مجموعة
              </button>
              <button
                className={
                  activeGraph === "year"
                    ? "active-button"
                    : "inactive-button-left"
                }
                onClick={() => handleButtonClick("year")}
              >
                لكل سنة
              </button>
              <div className="heading-style"> عدد نتائج البحث</div>
            </div>
          </div>

          <div className="graph-div-style">
            {activeGraph === "collection" && (
              <BarChart
                ref={chartRef}
                width={825}
                height={450}
                margin={{
                  top: 50,
                  right: 50,
                  bottom: 120,
                  left: 50,
                }}
                data={analyticsPerCollectionData}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="key"
                  padding={{ left: 30, right: 30 }}
                  label={{ value: "المجموعات", dy: 120 }}
                  className="label-style"
                  angle={-45}
                  interval={0}
                  textAnchor="end"
                  tickMargin={5}
                  tick={{
                    fontSize: analyticsPerCollectionData?.length > 12 ? 15 : 20,
                  }}
                />
                <YAxis
                  tickFormatter={(value) => toArabicNumber(value.toString())}
                  className="label-style"
                  label={{
                    value: "عدد نتائج البحث",
                    position: "insideLeft",
                    angle: -90,
                    dy: 50,
                    offset: -20,
                  }}
                />
                <Tooltip />
                <Bar name="Matches" dataKey="doc_count" fill="#427E93" />
              </BarChart>
            )}
          </div>

          <div className="graph-div-style">
            {activeGraph === "year" && (
              <ComposedChart
                width={825}
                height={425}
                margin={{ top: 50, right: 50, bottom: 50, left: 50 }}
                data={analyticsPerYearData}
                ref={chartRef}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="key_as_string"
                  padding={{ left: 30, right: 30 }}
                  label={{ value: "سنين", dy: 70 }}
                  className="label-style"
                />
                <YAxis
                  label={{
                    value: "عدد المباريات",
                    position: "insideLeft",
                    angle: -90,
                    offset: -10,
                    dy: 50,
                  }}
                  tickFormatter={(value) => toArabicNumber(value.toString())}
                  className="label-style"
                />
                <Tooltip />
                <Bar
                  name="Matches"
                  dataKey="doc_count"
                  barSize={50}
                  fill="#427E93"
                />
                <Line />
                <Brush />
              </ComposedChart>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: "20px",
          }}
        >
          <button
            className="active-button"
            style={{ marginRight: "25px" }}
            onClick={handleChartDownload}
          >
            تنزيل الرسم البياني
          </button>
          <button className="active-button" onClick={handleResultsDownload}>
            تنزيل النتائج
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AnalyticsArabic;
